import React, {useEffect} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction} from "mobx";
import PropTypes from "prop-types";

function ExportRow(props) {
  const store = useLocalObservable(() => ({list: [], fetching: false, inited: false}));
  useEffect(() => {
    // mount

    return () => {
      // unmount
    }
  }, []);


  return (
    <label htmlFor={`chk-${props.linker.value.code}`}>
      <div className={`vpadd5 solid1-bottom bo-w2 ${props.linker.value.export?"":"op60"}`}>
        <div className="up12 margin pointer">
          <div className="cell s-shrink pleft5">
            <label>
              <input checked={props.linker.value.export}
                     onChange={(e)=>{ runInAction(()=>{ props.linker.value.export=e.target.checked; }); }}
                     id={`chk-${props.linker.value.code}`}
                     type="checkbox"
              /><span></span>
            </label>
          </div>
          <div className="cell s-4">
            {props.linker.value.name}
          </div>
          <div className="cell s-4">
            {props.linker.value.code}
          </div>
          <div className="cell s-auto">

          </div>
        </div>
      </div>
    </label>
  )
};

ExportRow.defaultProps = {};

ExportRow.propTypes = {}

export default observer(ExportRow);
